import {SemanticTypes} from '../../preprocess/conversionDataBuilders'

export const TOP_BOTTOM_RELATION = {
    [SemanticTypes.TEXT]: {
        [SemanticTypes.BOX]: 24,
        [SemanticTypes.IMAGE]: 24,
        [SemanticTypes.TEXT]: 12,
        [SemanticTypes.BUTTON]: 32,
        [SemanticTypes.HORIZONTAL_LINE]: 32,
        [SemanticTypes.SVG]: 16
    },
    [SemanticTypes.IMAGE]: {
        [SemanticTypes.BOX]: 24,
        [SemanticTypes.IMAGE]: 24,
        [SemanticTypes.TEXT]: 32,
        [SemanticTypes.BUTTON]: 32,
        [SemanticTypes.HORIZONTAL_LINE]: 32,
        [SemanticTypes.SVG]: 24
    },
    [SemanticTypes.BOX]: {
        [SemanticTypes.BOX]: 24,
        [SemanticTypes.IMAGE]: 24,
        [SemanticTypes.TEXT]: 24,
        [SemanticTypes.BUTTON]: 32,
        [SemanticTypes.HORIZONTAL_LINE]: 32,
        [SemanticTypes.SVG]: 24
    },
    [SemanticTypes.HORIZONTAL_LINE]: {
        [SemanticTypes.BOX]: 32,
        [SemanticTypes.IMAGE]: 32,
        [SemanticTypes.TEXT]: 32,
        [SemanticTypes.BUTTON]: 32,
        [SemanticTypes.HORIZONTAL_LINE]: 32,
        [SemanticTypes.SVG]: 32
    },
    [SemanticTypes.BUTTON]: {
        [SemanticTypes.BOX]: 32,
        [SemanticTypes.IMAGE]: 32,
        [SemanticTypes.TEXT]: 32,
        [SemanticTypes.BUTTON]: 12,
        [SemanticTypes.HORIZONTAL_LINE]: 32,
        [SemanticTypes.SVG]: 32
    },
    [SemanticTypes.SVG]: {
        [SemanticTypes.BOX]: 32,
        [SemanticTypes.IMAGE]: 32,
        [SemanticTypes.TEXT]: 16,
        [SemanticTypes.BUTTON]: 32,
        [SemanticTypes.HORIZONTAL_LINE]: 32,
        [SemanticTypes.SVG]: 24
    }
}
export const TOP_PADDING = {
    ROOT: 40,
    DESCENDANT: 24
}
export const BOTTOM_PADDING = {
    ROOT: 40,
    DESCENDANT: 24,
    CELL: 18
}
export const SECTION_MARGIN_CLAMP = {
    MIN: 40,
    MAX: 200
}
export const LIST_ITEM_PADDING_TOP = 40
export enum HeightType {
    Auto,
    Fixed,
    AspectRatio,
    Percentage
}

export const FIT_TO_SCREEN = {
    VH_THRESHOLD: 80,
    FULL_VH: 100
}

export const HEADER_COMPONENTS_HEIGHT = {
    COMPONENT_IN_MENU_TOP_MARGIN: 16,
    COMPONENT_IN_HEADER_TOP_MARGIN: 8
}
import type {KeywordSize, LayoutSize, MinMaxSize} from '@wix/document-services-types'

export const fractionRowDefinition: LayoutSize = {
    type: 'fr',
    value: 1
}

export const minMaxRowDefinition: MinMaxSize = {
    type: 'MinMaxSize',
    min: {
        type: 'spx',
        value: 200
    },
    max: {
        type: 'maxContent'
    }
}

export const minContentRowDefinition: KeywordSize = {
    type: 'minContent'
}

export const cssGridLargeRowDefinition: MinMaxSize = {
    type: 'MinMaxSize',
    min: {
        type: 'spx',
        value: 200
    },
    max: {
        type: 'auto'
    }
}

export const cssGridDefaultRowDefinition: MinMaxSize = {
    type: 'MinMaxSize',
    min: {
        type: 'spx',
        value: 12
    },
    max: {
        type: 'auto'
    }
}
